import { Component, Input } from '@angular/core';
import { NotificacaoDto } from '@usucampeao/lib-reurb-simplificado';

@Component({
  selector: 'usucampeao-projeto-aprovado-pela-prefeitura',
  templateUrl: './projeto-aprovado-pela-prefeitura.component.html',
  styleUrls: ['./projeto-aprovado-pela-prefeitura.component.scss'],
})
export class ProjetoAprovadoPelaPrefeituraComponent {
  @Input() public notificacao: NotificacaoDto;
}
